var _ellipse, _path, _rect, _rect2, _rect3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViolatedterms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1238 1.62511C17.6183 0.768559 18.7919 0.616705 19.4882 1.31918L25.3518 7.23527C25.6146 7.50041 25.9334 7.70333 26.2849 7.82914L34.1278 10.6366C35.0089 10.952 35.3893 11.9883 34.9213 12.7988L31.8178 18.1744C31.3498 18.9848 30.2621 19.1736 29.5484 18.5683L23.1957 13.1798C22.911 12.9383 22.5758 12.7637 22.2148 12.6687L14.1595 10.5487C13.203 10.2969 12.7477 9.20462 13.2423 8.34806L17.1238 1.62511Z",
    fill: "white",
    stroke: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.1112,
    y: 5.52286,
    width: 5,
    height: 21,
    rx: 0.5,
    transform: "rotate(30 24.1112 5.52286)",
    fill: "white",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 22.5,
    width: 13,
    height: 3,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2453,
    y: 13.683,
    width: 7,
    height: 3,
    rx: 0.5,
    transform: "rotate(30 18.2453 13.683)",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1982 20.5H13.8018V10.7969H10.1982V20.5ZM12 10.2607C13.0195 10.2607 13.793 9.52246 13.793 8.55566C13.793 7.58887 13.0195 6.85059 12 6.85059C10.9805 6.85059 10.207 7.58887 10.207 8.55566C10.207 9.52246 10.9805 10.2607 12 10.2607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolatedterms);
export default __webpack_public_path__ + "static/media/violatedterms.72326bf1e70c64544fa8c60b0f111c10.svg";
export { ForwardRef as ReactComponent };